import eventLogger from "@/app/eventlogging/eventLogger";

const violationsLogged = new Set<string>();

const logViolation = (violationDescription: string, debugHint = "") => {
  if (!violationsLogged.has(violationDescription)) {
    violationsLogged.add(violationDescription);
    eventLogger.logEvent("FE Assert Violation", {
      violationDescription,
      debugHint,
    });
  }
};

const assertLogger = {
  logViolation,
};

export default assertLogger;
